// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_3OL","cls2":"JournalSubscriptionPage-cls2_nKP JournalSubscriptionPage-cls1_3OL"};